// SEMANTIC (out-of-the-box)
import {
  Accordion,
  Card,
  Checkbox,
  Container,
  Divider,
  Dimmer,
  Dropdown,
  Header,
  Image,
  Input,
  Item,
  Label,
  List,
  Loader,
  Menu,
  Message,
  Modal,
  Popup,
  Search,
  Segment,
  Statistic,
  Step,
  Sticky,
  Table,
  Transition,
} from 'semantic-ui-react'

export default {
  // SEMANTIC
  Accordion,
  Card,
  Checkbox,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Header,
  Image,
  Input,
  Item,
  Label,
  List,
  Loader,
  Menu,
  Message,
  Modal,
  Popup,
  Search,
  Segment,
  Statistic,
  Step,
  Sticky,
  Table,
  Transition,
}
